/* Conversation Cards product page.
   Two things:
   · the framed preview reports its own height (and whether a deck is open), so
     the frame grows with the deck and the page scrolls as one; while a deck is
     open the frame takes the viewport and scrolls into view.
   · the star-ball turns with the page scroll. */
(function () {
  'use strict';

  var frame = document.getElementById('cardsTrial');
  if (frame) {
    var playing = false;
    var contentHeight = 900;
    var apply = function () {
      frame.style.height = (playing ? window.innerHeight : contentHeight) + 'px';
    };
    window.addEventListener('message', function (e) {
      var d = e.data || {};
      if (d.cc !== 'size') return;
      if (d.playing && !playing) {
        playing = true;
        apply();
        frame.scrollIntoView({ block: 'start' });
        return;
      }
      if (!d.playing && playing) playing = false;
      if (!d.playing && d.h > 200) contentHeight = d.h;
      apply();
    });
    window.addEventListener('resize', apply);
  }

  var ball = document.getElementById('cardsBall');
  if (ball && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var spin = function () {
      ball.style.transform = 'rotate(' + window.scrollY * 0.12 + 'deg)';
    };
    window.addEventListener('scroll', spin, { passive: true });
    spin();
  }
})();
